'use strict';
const angular = require('angular');
const {isUndefined} = angular;

module.exports = [
  '$parse',
  OnEditDirective];

function OnEditDirective($parse) {

  return function postLink($scope, $element, $attrs) {

    let isEnabled = false;
    let handler;
    try {
      handler = $parse($attrs.onEdit);
    } catch (error) {
      console.warn('onEdit failed to parse method to call. Expected function as attribute. ' + $element);
      return;
    }

    if (!isUndefined($attrs.canEdit)) {
      $attrs.$observe('canEdit', function (canEdit) {
        canEdit = canEdit === 'true';
        if (canEdit && !isEnabled) {
          enable();
        } else if (!canEdit && isEnabled) {
          disable();
        }
      });
    } else {
      enable();
    }

    $scope.$on('$destroy', cleanup);

    function enable() {
      $element.addClass('edit-on-hover');
      $element.on('click', onClick);
      isEnabled = true;
    }

    function disable() {
      $element.removeClass('edit-on-hover');
      $element.off('click', onClick);
      isEnabled = false;
    }

    function onClick(e) {
      $scope.$apply(function () {
        if (e.offsetX > (e.currentTarget.offsetWidth - 40)) {
          handler($scope, {$event: e});
        }
      });
    }

    function cleanup() {
      if (isEnabled) {
        $element.off('click', onClick);
        isEnabled = false;
      }
    }
  };
}



// WEBPACK FOOTER //
// ./src/js/core-components/EditPanels/OnEditDirective.js